// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--lqFia";
export var content = "styles-module--content--q7VfT";
export var left = "styles-module--left--QX8rj";
export var right = "styles-module--right--dFvaD";